import { Blob, File } from '@consigli/types';
import { useCallback, useState } from 'react';

export const useViewDetails = () => {
  const [selectedItem, setSelectedItem] = useState<Blob | File | null>(null);
  const [isDetailViewOpen, setIsDetailViewOpen] = useState(false);

  const handleViewDetailsClick = useCallback((item: Blob | File) => {
    setSelectedItem(item);
    setIsDetailViewOpen(true);
  }, []);

  return {
    selectedItem,
    isDetailViewOpen,
    setSelectedItem,
    setIsDetailViewOpen,
    handleViewDetailsClick,
  };
};
